// Ortak doğrulama yardımcıları

// E-posta format doğrulama.
// Boş değer GEÇERLİ sayılır (alanın zorunlu olup olmadığı ayrıca kontrol edilir).
// Doluysa temel format kontrolü uygulanır.
const MAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function mailGecerli(value) {
  if (value === null || value === undefined) return true;
  const v = String(value).trim();
  if (v === "") return true;
  return MAIL_REGEX.test(v);
}

// Telefon format doğrulama — E.164 (+ ile başlayan, 7-15 haneli).
// Boş değer GEÇERLİ sayılır (alanın zorunlu olup olmadığı ayrıca kontrol edilir).
const E164_REGEX = /^\+[1-9]\d{6,14}$/;

export function telefonGecerli(value) {
  if (value === null || value === undefined) return true;
  const v = String(value).trim();
  if (v === "") return true;
  return E164_REGEX.test(v);
}

// TLF1: eski/ham TR numarasını (05321234567, 905321234567) E.164'e çevirir; "+" ile başlayan ya da
// tanınmayan değer olduğu gibi döner. TelefonGirisi ve kayıttan dolan ödeme/kayıt formları kullanır.
export function telefonE164Yap(value, varsayilanKod = "+90") {
  const v = value ? String(value).trim() : "";
  if (!v || v.startsWith("+")) return v;
  const r = v.replace(/[^\d]/g, "");
  if (varsayilanKod !== "+90" || !r) return v;
  if (r.length === 11 && r.startsWith("0")) return "+90" + r.slice(1);
  if (r.length === 12 && r.startsWith("90")) return "+" + r;
  if (r.length === 10 && r.startsWith("5")) return "+90" + r;
  return v;
}
